export default {
  animation: false,
  xAxis: {
    axisLine: {
      show: true,
    },
    axisTick: {
      show: false,
    },
    axisLabel: {
      show: true,
    },
    splitLine: {
      show: true,
    },
    splitArea: {
      show: true,
    },
  },
  yAxis: {
    axisLine: {
      show: true,
    },
    axisTick: {
      show: false,
    },
    axisLabel: {
      show: true,
    },
    splitLine: {
      show: true,
    },
    splitArea: {
      show: false,
    },
    nameLocation: 'middle',
  },
  grid: {
    top: '20px',
    bottom: '20px',
    left: '25px',
    right: 0,
  },
  tooltip: {
    transitionDuration: 0,
    axisPointer: {
      animation: false,
    },
    textStyle: {
      fontSize: 11,
    },
  },
};
